import { Modal, Platform, StyleSheet, TouchableOpacity, useWindowDimensions, View } from 'react-native'
import React from 'react'
import { create } from 'zustand'
import { AVBlocked } from './AVBlocked'
import { AVAllow } from './AVAllow'
import Close from '../../../assets/X--enclosed.svg'
import { DS } from '../../../../../design-system'
import { palette } from '../../../../../theme/palette'
import ChipsPinkMaroon from '../../../assets/ChipsPinkMaroon.svg'
import { CloseSVG } from '@/components/ANewDesign/TeacherControl/assets/CloseSVG'

type BlockedPermission = 'camera' | 'microphone'

type AVPermissionsConfig = {
  isAllowPrompted?: boolean
  blockedPermission?: BlockedPermission | undefined
  isAVPermissionsOpen: boolean
}
interface AVPermissionStore {
  permissionConfig: AVPermissionsConfig
  setPermissionConfig: (config: AVPermissionsConfig) => void
}

export const useAVPermissions = create<AVPermissionStore>((set) => ({
  permissionConfig: {
    isAllowPrompted: false,
    blockedPermission: undefined,
    isAVPermissionsOpen: false
  },
  setPermissionConfig: (permissionConfig) => set(() => ({ permissionConfig }))
}))

export const AVPermissionsModal = () => {
  const { width } = useWindowDimensions()
  const isSmallDevice = width < 600
  const {
    permissionConfig: { isAVPermissionsOpen, isAllowPrompted, blockedPermission },
    setPermissionConfig
  } = useAVPermissions()
  return (
    <View>
      <Modal
        visible={isAVPermissionsOpen}
        animationType="fade"
        transparent={true}
        style={Platform.OS === 'android' ? { flex: 1, margin: 0 } : {}}
      >
        {isAVPermissionsOpen && (
          <View style={styles.layout}>
            <DS.Frame style={[styles.container, { flexDirection: isSmallDevice ? 'column' : 'row' }]} gap="32">
              <DS.Frame style={styles.chipsContainer}>
                <DS.Frame style={{ position: 'absolute', top: -32 }}>
                  <ChipsPinkMaroon width={64} height={64} />
                </DS.Frame>
              </DS.Frame>
              <TouchableOpacity
                onPress={() => {
                  setPermissionConfig({
                    isAVPermissionsOpen: false
                  })
                }}
                style={{ padding: 8, position: 'absolute', right: 8, top: 8 }}
              >
                <CloseSVG />
              </TouchableOpacity>
              {isAllowPrompted ? <AVAllow /> : <AVBlocked blockedPermission={blockedPermission} />}
            </DS.Frame>
          </View>
        )}
      </Modal>
    </View>
  )
}

const styles = StyleSheet.create({
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(33,33,33,0.85)'
  },
  container: {
    backgroundColor: palette.cream,
    borderRadius: 12,
    paddingHorizontal: 32,
    paddingVertical: 64,
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 800,
    width: '95%'
  },
  chipsContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 30,
    alignItems: 'center'
  }
})
